import { Config } from "@planetscale/database";
import { eq } from "drizzle-orm";
import { Link, redirect } from "react-router";
import { requireSess } from "~/auth.server";
import { formatDate } from "~/components/site/Date";
import { Breadcrumb } from "~/components/ui/Breadcrumb";
import { PageTitle } from "~/components/ui/PageTitle";
import { Table } from "~/components/ui/Table";
import { pg } from "~/pg.server";
import { lstring, useT, useTurl } from "~/util/Lang";
import { $LOADER, $PAGE, MetaArgs, OurLoaderArgs } from "~/util/Loaders";
import { logPageView } from "~/util/stats";
import { homePage } from "~/util/titles";

async function makeData(args: OurLoaderArgs, cfg: Config) {
  // Log
  logPageView(args);
  //
  const pages = await pg.db
    .select({
      id: pg.pages.id,
      title: pg.pages.title,
      content: pg.pages.content,
      lang: pg.pages.lang,
      game: pg.pages.game,
      createdAt: pg.pages.createdAt,
      user: { login: pg.users.login },
    })
    .from(pg.pages)
    .innerJoin(pg.users, eq(pg.pages.userId, pg.users.id));

  return { pages };
}

type LoaderData = Awaited<ReturnType<typeof makeData>>;

function makeMeta(
  cx: MetaArgs<LoaderData>,
  opts: { title: lstring; canonicalPath?: string }
) {
  return {
    title: `${cx.t({ en: "Pages", ru: "Страницы" })} - ${homePage(cx.realm)}`,

    ogTitle: `Lineage 2 Item Sets`,
  };
}

$PAGE({
  path: "pages",
  loader: $LOADER?.((la) => {
    return makeData(la, {});
  }),
  meta: (cx) =>
    makeMeta(cx, {
      title: { en: "Pages", ru: "Страницы" },
      canonicalPath: "/pages",
    }),
  render: ({ data }) => {
    const t = useT();
    const turl = useTurl();
    const { pages } = data;
    const pageTitle = t({ en: "Pages", ru: "Страницы" });

    return (
      <div>
        <div className="content">
          <Breadcrumb items={[{ title: pageTitle, url: turl("/pages") }]} />
          <PageTitle>{pageTitle}</PageTitle>
        </div>
        <Link to={"/pages/create"}>Create</Link>
        <Table
          data={pages}
          id={(page, index) => index}
          cols={[
            {
              title: t({ en: "Name", ru: "Имя" }),
              cell: (page) => (
                <Link to={turl("/pages/" + page.id)}>{page.title}</Link>
              ),
            },
            {
              title: t({ en: "Author", ru: "Автор" }),
              cell: (page) => page.user.login,
            },
            {
              title: t({ en: "Lang", ru: "Язык" }),
              cell: (page) => page.lang,
            },
            {
              title: t({ en: "Version", ru: "Версия" }),
              cell: (page) => page.game,
            },
            {
              title: t({ en: "Created At", ru: "Создано" }),
              cell: (page) => formatDate(page.createdAt),
            },
          ]}
        />
      </div>
    );
  },
});
